import type { Account, Channel } from '../../../common/types'

export type ChannelRefreshBannerOptions = {
  isIgLoginRefreshEnabled: boolean
}

export const channelRequiresRefresh = (
  channel: Channel,
  { isIgLoginRefreshEnabled }: ChannelRefreshBannerOptions,
): boolean => {
  // Locked channels can't be refreshed until they are unlocked
  if (channel.isLocked) {
    return false
  }

  return Boolean(
    channel.shouldShowPinterestUpgradeBanner ||
    channel.shouldShowLinkedInUpgradeBanner ||
    channel.shouldShowTiktokUpgradeBanner ||
    (isIgLoginRefreshEnabled && channel.shouldShowIgLoginRefreshBanner),
  )
}

export const shouldShowChannelRefreshBanner = (
  user: Account,
  options: ChannelRefreshBannerOptions,
): boolean =>
  Boolean(
    user.currentOrganization?.channels?.some((channel) =>
      channelRequiresRefresh(channel, options),
    ),
  )
